var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconnotificationTrayanalyticsShortcut = function SvgIconnotificationTrayanalyticsShortcut(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Dashboard/icon.analytics_shortcut") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dashboard/icon.analytics_shortcut",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bathroom",
    transform: "translate(4.500000, 9.750000)",
    stroke: "#09BE86",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 9.75,
    x2: 0.5,
    y2: 5.25,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.8125,
    y1: 9.75,
    x2: 3.8125,
    y2: 1.5,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 9.75,
    x2: 7,
    y2: 3,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.1875,
    y1: 9.625,
    x2: 10.1875,
    y2: 0.875,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 9.75,
    x2: 13.5,
    y2: 5.25,
    id: "Line-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22,12.5 L22,22.3 C22,22.6865993 21.6865993,23 21.3,23 L1.7,23 C1.31340068,23 1,22.6865993 1,22.3 L1,2.7 C1,2.31340068 1.31340068,2 1.7,2 L11.5,2",
    id: "Path",
    stroke: "#09BE86",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7142857,1 C19.0111571,1 20.4397286,1 23,1 L23,5.28571429 M23,1 L18,6",
    id: "Combined-Shape",
    stroke: "#09BE86",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconnotificationTrayanalyticsShortcut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.notification_tray.analytics_shortcut.f47e770af6fc6c751ecd966c0e3f98a7.svg";